var map = {
	"./+.svg": "e849",
	"./BlueSetting.svg": "9b24",
	"./Calendar.svg": "7c8b",
	"./Call.svg": "48c6",
	"./Chart.svg": "3641",
	"./Discount.svg": "7c36",
	"./Discovery.svg": "abbc",
	"./Document.svg": "7eb2",
	"./Edit.svg": "3efa",
	"./Game.svg": "8254",
	"./Hide.svg": "4396",
	"./History.svg": "1993",
	"./Line.svg": "a070",
	"./Logout-mobile.svg": "93d0",
	"./Message.svg": "52ca",
	"./MoreSquare.svg": "d85f",
	"./MoresSquare.svg": "2110",
	"./Plus.svg": "6f54",
	"./Reload.svg": "214c",
	"./Setting.svg": "4052",
	"./VolumeUp.svg": "c73d",
	"./addBtn.svg": "e3c5",
	"./analytics/check.svg": "62a1",
	"./analytics/coin.svg": "94bd",
	"./analytics/customer.svg": "8541",
	"./analytics/middle.svg": "680c",
	"./analytics/numUser.svg": "f402",
	"./analytics/orders.svg": "be42",
	"./analytics/spent.svg": "a9e7",
	"./app.svg": "33c2",
	"./back-top.svg": "a34b",
	"./bgNotification.svg": "9042",
	"./bird.svg": "0d78",
	"./birsday.svg": "d4b9",
	"./blue_plus.svg": "9c2d",
	"./chat-empty.svg": "3bd9",
	"./chat.svg": "9b69",
	"./check_blue.svg": "3839",
	"./check_mark.svg": "734d",
	"./circlequestion.svg": "42b7",
	"./clientUser.svg": "bf42",
	"./clientbase.svg": "9177",
	"./coupon.svg": "7a64",
	"./deleteClient.svg": "db19",
	"./discountProfile.svg": "4f9d",
	"./doubt.svg": "4067",
	"./down.svg": "d8aa",
	"./download.svg": "f28e",
	"./edit-profile.svg": "8565",
	"./editUserAvatar.svg": "a136",
	"./empty-chat.png": "01a7",
	"./emptyOrder.svg": "e01c",
	"./enable+.svg": "4981",
	"./exportError.svg": "b304",
	"./eye.svg": "7364",
	"./facebook.svg": "8485",
	"./filter-btn.png": "36f0",
	"./filter-btn.svg": "45bd",
	"./filter.svg": "2376",
	"./filtering.svg": "8b28",
	"./google.svg": "d950",
	"./greenCheck.svg": "d62a",
	"./greyArrowLeft.svg": "963d",
	"./greyX.svg": "c2b3",
	"./group.svg": "51a3",
	"./import.svg": "5d78",
	"./isVisible.svg": "5838",
	"./list.svg": "99ad",
	"./location.svg": "d2eb",
	"./log-basket.svg": "f4c6",
	"./log-edit.svg": "78f0",
	"./log-minus.svg": "3a58",
	"./log-out.svg": "3367",
	"./log-plus.svg": "22e5",
	"./log-point.svg": "c30d",
	"./logs.svg": "50ac",
	"./menu.svg": "d17f",
	"./moveto.svg": "20ad",
	"./new.svg": "bdaf",
	"./no-catalog.svg": "7ba9",
	"./no-news.jpg": "0816",
	"./no-news.png": "7349",
	"./no-news.svg": "ba80",
	"./noProd.png": "ccdf",
	"./noProd.svg": "b209",
	"./noProd2.svg": "1c45",
	"./nonsee.svg": "de37",
	"./notification.svg": "768d",
	"./notification1.svg": "9825",
	"./polygon.svg": "baf3",
	"./prevArrow.svg": "383e",
	"./printer.svg": "345d",
	"./pro.svg": "d22a",
	"./profile-img.svg": "aaf8",
	"./promo_discount.svg": "382d",
	"./promotion.svg": "7247",
	"./qr-code.svg": "3a65",
	"./qr_icon.svg": "10bd",
	"./question.svg": "9872",
	"./redTrash.svg": "c4ff",
	"./redX.svg": "d919",
	"./redXRound.svg": "a08d",
	"./ring.svg": "1f29",
	"./roundMinus.svg": "4764",
	"./roundPlus.svg": "9a66",
	"./search-icon.svg": "7669",
	"./searchGrey.svg": "45b4",
	"./see.svg": "1e87",
	"./select.svg": "9878",
	"./selectDown.svg": "fc93",
	"./send-individual.svg": "e323",
	"./sendMessage.svg": "d725",
	"./set.svg": "1576",
	"./setting-icon/Chart.svg": "aaf3",
	"./setting-icon/Discovery.svg": "a7c4",
	"./setting-icon/Document.svg": "9797",
	"./setting-icon/Game.svg": "2b84",
	"./setting-icon/Lock.svg": "c180",
	"./setting-icon/MoreSquare.svg": "1ef2",
	"./setting-icon/Plus.svg": "9cf3",
	"./setting-icon/Setting.svg": "0e6a",
	"./setting-icon/Unblock.svg": "a0cc",
	"./setting-icon/VolumeUp.svg": "7271",
	"./setting-icon/big-img.svg": "bb9c",
	"./setting-icon/no-img.svg": "306d",
	"./setting-icon/paper.svg": "7679",
	"./side-arrow.svg": "6539",
	"./start-setting.svg": "cd01",
	"./three-dot-hover.svg": "b9e0",
	"./three-dots.svg": "0960",
	"./trash_empty.svg": "78da",
	"./true.svg": "c7c4",
	"./twitter.svg": "acf9",
	"./uil_file-upload.svg": "cc1c",
	"./uploadExcel.svg": "f843",
	"./urlIcon.svg": "666d",
	"./x.svg": "7387",
	"./xBlack.svg": "a48c",
	"./xGrey.svg": "d6b9",
	"./xWhite.svg": "a172",
	"./x_round_grey.svg": "6c78",
	"./xreset.svg": "8dc2",
	"./xx.svg": "a3bd",
	"./yesterday.svg": "9c49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";